/* import __COLOCATED_TEMPLATE__ from './billing-page.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './billing-page.module.scss';

@classic
@classNames(styles.component)
export default class SiteBillingPage extends Component {}
